<template>
<main>
<v-container class="grey lighten-4 fill-height" fluid>

              <v-card class="elevation-12 ma-3   mx-auto">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Kontoinställningar</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
  <!-- <h3>Profil</h3> -->
  <v-form ref="form">
            <v-row>
              <v-col>
                <v-text-field
                    v-model="fname"
                    :rules="nameRules"
                    label="Förnamn"
                    required
                    outlined
                ></v-text-field>
                </v-col>
                    <v-col>
                <v-text-field
                    v-model="lname"
                    :rules="nameRules"
                    label="Efternamn"
                    required
                    outlined
                ></v-text-field>
                </v-col>
            </v-row>
            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Din mail"
                required
                outlined
            ></v-text-field>

            <v-alert type="success" v-show="alert" dismissible>
            Profil uppdaterad.
            </v-alert>
            <v-btn
                block
                style="background-color:#ffa500"
                class="my-3"
                v-on:click="submit"
                :loading="loading"
            >
                Uppdatera profil
            </v-btn>
        </v-form>
        <!-- <v-row class="mt-5"> -->
        <!-- <h3>Ändra lösenord</h3>
        </v-row>
        <v-row> -->
  <v-btn
  block
        text
        class="themecolor my-3"
        to="/changepassword"
      >
        Ändra lösenord
      </v-btn>
       <!-- </v-row>
       
        <v-row class="mt-5">
        <h3>Radera konto</h3>
        </v-row>
        <v-row> -->
  <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        block
          color="red lighten-2 my-3"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Radera konto
        </v-btn>
      </template>

      <v-card>
          <v-card-title
          primary-title
        >
        </v-card-title>
        <v-card-text>
           Är du säker på att radera ditt konto?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Annullera
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteAccount"
          >
            Radera konto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
       <!-- </v-row> -->
                </v-card-text>
            </v-card>
  </v-container>
  
  </main>
</template>


<script>
import store from "../../../store";
import axios from "axios";
  export default {
    data () {
      return {
        store: store,
        user: [],
        loading: false,
        valid: false,
        alert: false,
        dialog: false,
        fname: "",
        lname: "",
        nameRules: [v => !!v || "Namn krävs"],
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Ange giltigt e-postmeddelande"
        ],
      }
    },
    created: async function() {
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}user/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.user = resp.data.user;
        this.fname = this.user.first_name
        this.lname = this.user.last_name
        this.email = this.user.email
    },
    
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async submit() {
            this.loading = true;
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("id", this.user.id);
            bodyFormData.set("first_name", this.fname);
            bodyFormData.set("last_name", this.lname);
            bodyFormData.set("email", this.email);
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}userupdate`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.$refs.form.validate()) {
                await axios(config)
                .then(resp => {
                    this.user = resp.data.user;
                    this.loading = false
                    this.alert = true;
                })
            } else {
                this.store.state.showAlert = true;
                this.store.state.alertMsg = "Fyll i lämplig information";
                this.store.state.alertType = "error";
                this.loading = false
            }
        },
        deleteAccount() {
            let url = `${this.store.state.baseURL}deleteuser/${this.store.state.user.id}`;
            axios.get(url);
            this.store.dispatch("logout");
            this.$router.replace("/");
        }
    }
  }
</script>
<style>
.themecolor {
  color:#ffa500 !important;
}
</style>